var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useState } from "react";
import { Pane, Row, Col, AccordionSet, Accordion, PaneFooter, ErrorModal, Button, MultiColumnList, Checkbox, MessageBanner, } from "@folio/stripes/components";
import { useIntl, FormattedMessage } from "react-intl";
import { Controller } from "react-hook-form";
import { RecekTextField, RecekSelect } from "../inputs";
import { PublisherContactInputTypeEnum, PublisherContactTypeEnum, PublisherOwnerEnum, } from "../../types/Api";
import { RecekPaneSet } from "../RecekPaneSet";
import { ExpandCollapseToggle } from "../ExpandCollapseToggle";
import { FormFooterStart } from "../FormFooterStart";
import { FormFooterEnd } from "../FormFooterEnd";
import { InfoBox, InfoBoxTypeEnum } from "../InfoBox";
import { FieldRow } from "../FieldRow";
import { formatDate } from "../../utils/formatUtils";
import { usePublisherContactsForm } from "../../hooks/usePublisherContactsForm";
import { useScrollToError } from "../../hooks/useScrollToError";
import { extractServerErrorMessage } from "../../utils/errorHandler";
var PublisherContactsForm = function (_a) {
    var _b, _c, _d;
    var initialValues = _a.initialValues, onSubmit = _a.onSubmit, title = _a.title, onCancel = _a.onCancel;
    var formatMessage = useIntl().formatMessage;
    var _e = useState({
        general: true,
        contacts: true,
    }), accordionStatus = _e[0], setAccordionStatus = _e[1];
    var _f = useState(true), expandAll = _f[0], setExpandAll = _f[1];
    var _g = useState(false), errorModalOpen = _g[0], setErrorModalOpen = _g[1];
    var _h = useState(""), errorMessage = _h[0], setErrorMessage = _h[1];
    var _j = usePublisherContactsForm(initialValues), syncedContacts = _j.syncedContacts, _k = _j.contactForm, handleSubmit = _k.handleSubmit, control = _k.control, errors = _k.formState.errors, fields = _j.fields, regionName = _j.regionName, removeContact = _j.removeContact, handleAddContact = _j.handleAddContact, prepareSubmitData = _j.prepareSubmitData;
    var toggleExpandCollapseAll = function () {
        setAccordionStatus({
            general: !expandAll,
            contacts: !expandAll,
        });
        setExpandAll(!expandAll);
    };
    useScrollToError(errors);
    var handleFormSubmit = function (data) { return __awaiter(void 0, void 0, void 0, function () {
        var publisherData, error_1, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 4]);
                    publisherData = prepareSubmitData(data);
                    return [4 /*yield*/, onSubmit(publisherData)];
                case 1:
                    _b.sent();
                    return [3 /*break*/, 4];
                case 2:
                    error_1 = _b.sent();
                    _a = setErrorMessage;
                    return [4 /*yield*/, extractServerErrorMessage(error_1, formatMessage, formatMessage({
                            id: "ui-br-legaldeposits.publishers.edit.error.save",
                        }))];
                case 3:
                    _a.apply(void 0, [_b.sent()]);
                    setErrorModalOpen(true);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    return (React.createElement(RecekPaneSet, null,
        React.createElement(Pane, { id: "contentPane", defaultWidth: "fill", paneTitle: title, footer: React.createElement(PaneFooter, { renderStart: React.createElement(FormFooterStart, { handleSubmit: handleSubmit, onSubmit: handleFormSubmit, buttonMessageId: "ui-br-legaldeposits.button.save" }), renderEnd: React.createElement(FormFooterEnd, { onCancel: onCancel, buttonMessageId: "ui-br-legaldeposits.button.cancel" }) }) },
            React.createElement(ErrorModal, { open: errorModalOpen, label: formatMessage({
                    id: "ui-br-legaldeposits.error.modal.title",
                }), content: errorMessage, onClose: function () { return setErrorModalOpen(false); } }),
            React.createElement(Row, null,
                React.createElement(Col, { xs: 12 },
                    React.createElement(InfoBox, { titleId: "ui-br-legaldeposits.publishers.list.info.title" },
                        React.createElement("p", null,
                            React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.publishers.edit.info.readonly" }))))),
            React.createElement(ExpandCollapseToggle, { expanded: expandAll, onToggle: toggleExpandCollapseAll }),
            React.createElement("form", { onSubmit: function (e) { return e.preventDefault(); } },
                React.createElement(AccordionSet, null,
                    React.createElement(Accordion, { label: formatMessage({
                            id: "ui-br-legaldeposits.publishers.accordion.general",
                        }), open: accordionStatus.general, onToggle: function () {
                            return setAccordionStatus(__assign(__assign({}, accordionStatus), { general: !accordionStatus.general }));
                        } },
                        React.createElement(Row, null,
                            React.createElement(Col, { xs: 12, md: 6 },
                                React.createElement(FieldRow, { labelId: "ui-br-legaldeposits.publishers.field.name", value: initialValues.name })),
                            React.createElement(Col, { xs: 12, md: 6 },
                                React.createElement(FieldRow, { labelId: "ui-br-legaldeposits.publishers.field.legalForm", value: initialValues.legalForm
                                        ? formatMessage({
                                            id: "ui-br-legaldeposits.publishers.field.label.name.".concat((_b = initialValues.legalForm) === null || _b === void 0 ? void 0 : _b.toLowerCase()),
                                        })
                                        : "" })),
                            React.createElement(Col, { xs: 12, md: 6 }, initialValues.companyNumber ? (React.createElement(FieldRow, { labelId: "ui-br-legaldeposits.publishers.field.companyNumber", value: initialValues.companyNumber })) : (React.createElement(FieldRow, { labelId: "ui-br-legaldeposits.publishers.field.birthDate", value: initialValues.birthDate
                                    ? formatDate(initialValues.birthDate)
                                    : "" }))),
                            React.createElement(Col, { xs: 12, md: 6 },
                                React.createElement(FieldRow, { labelId: "ui-br-legaldeposits.publishers.field.owner", value: initialValues.owner
                                        ? formatMessage({
                                            id: "ui-br-legaldeposits.publishers.owner.".concat(initialValues.owner),
                                        })
                                        : "" })),
                            React.createElement(Col, { xs: 12, md: 6 },
                                React.createElement(FieldRow, { labelId: "ui-br-legaldeposits.publishers.field.region", value: regionName !== null && regionName !== void 0 ? regionName : "" })))),
                    React.createElement(Accordion, { label: formatMessage({
                            id: "ui-br-legaldeposits.publishers.accordion.contacts",
                        }), open: accordionStatus.contacts, onToggle: function () {
                            return setAccordionStatus(__assign(__assign({}, accordionStatus), { contacts: !accordionStatus.contacts }));
                        } },
                        React.createElement(InfoBox, { type: InfoBoxTypeEnum.WARNING, customIcon: "\uD83D\uDCA1" },
                            React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.publishers.edit.info.contacts" })),
                        ((_d = (_c = errors.contacts) === null || _c === void 0 ? void 0 : _c.root) === null || _d === void 0 ? void 0 : _d.message) && (React.createElement("fieldset", { name: "contacts.root" },
                            React.createElement(MessageBanner, { type: "error" }, errors.contacts.root.message))),
                        syncedContacts.length > 0 && (React.createElement(React.Fragment, null,
                            React.createElement("h4", null,
                                React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.publishers.edit.contacts.synced" })),
                            React.createElement(MultiColumnList, { contentData: syncedContacts.map(function (contact, index) {
                                    var _a;
                                    return ({
                                        type: formatMessage({
                                            id: "ui-br-legaldeposits.publishers.contact.".concat(contact.type),
                                        }),
                                        value: contact.type === PublisherContactTypeEnum.WEB ? (React.createElement("a", { href: contact.value, target: "_blank", rel: "noopener noreferrer" }, contact.value)) : (contact.value),
                                        info: (_a = contact.info) !== null && _a !== void 0 ? _a : "",
                                        isPrimary: (React.createElement(Controller, { control: control, name: "syncedContacts.".concat(index, ".isPrimary"), render: function (_a) {
                                                var _b;
                                                var controllerField = _a.field;
                                                return (React.createElement(Checkbox, { checked: (_b = controllerField.value) !== null && _b !== void 0 ? _b : false, onChange: controllerField.onChange, "aria-label": formatMessage({
                                                        id: "ui-br-legaldeposits.publishers.field.contacts.isPrimary",
                                                    }) }));
                                            } })),
                                    });
                                }), visibleColumns: ["type", "value", "info", "isPrimary"], columnMapping: {
                                    type: formatMessage({
                                        id: "ui-br-legaldeposits.publishers.field.contacts.type",
                                    }),
                                    value: formatMessage({
                                        id: "ui-br-legaldeposits.publishers.field.contacts.value",
                                    }),
                                    info: formatMessage({
                                        id: "ui-br-legaldeposits.publishers.field.contacts.info",
                                    }),
                                    isPrimary: formatMessage({
                                        id: "ui-br-legaldeposits.publishers.field.contacts.isPrimary",
                                    }),
                                }, interactive: false }))),
                        React.createElement("h4", null,
                            React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.publishers.edit.contacts.local" })),
                        initialValues.owner === PublisherOwnerEnum.PUBLISHERS && (React.createElement(InfoBox, { type: InfoBoxTypeEnum.INFO },
                            React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.publishers.edit.contacts.local.noSyncBack" }))),
                        fields.length === 0 ? (React.createElement("p", null,
                            React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.publishers.edit.contacts.local.empty" }))) : (fields.map(function (field, index) { return (React.createElement(Row, { key: field.id },
                            React.createElement(Col, { xs: 12, sm: 6, md: 2 },
                                React.createElement(Controller, { control: control, name: "contacts.".concat(index, ".type"), render: function (_a) {
                                        var controllerField = _a.field;
                                        return (React.createElement(RecekSelect, __assign({}, controllerField, { labelId: "ui-br-legaldeposits.publishers.field.contacts.type", dataOptions: Object.values(PublisherContactInputTypeEnum).map(function (type) { return ({
                                                value: type,
                                                label: formatMessage({
                                                    id: "ui-br-legaldeposits.publishers.contact.".concat(type),
                                                }),
                                            }); }) })));
                                    } })),
                            React.createElement(Col, { xs: 12, sm: 6, md: 4 },
                                React.createElement(Controller, { control: control, name: "contacts.".concat(index, ".value"), render: function (_a) {
                                        var _b, _c, _d;
                                        var controllerField = _a.field;
                                        return (React.createElement(RecekTextField, __assign({}, controllerField, { labelId: "ui-br-legaldeposits.publishers.field.contacts.value", required: true, error: (_d = (_c = (_b = errors.contacts) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.value) === null || _d === void 0 ? void 0 : _d.message })));
                                    } })),
                            React.createElement(Col, { xs: 12, sm: 6, md: 4 },
                                React.createElement(Controller, { control: control, name: "contacts.".concat(index, ".info"), render: function (_a) {
                                        var _b;
                                        var controllerField = _a.field;
                                        return (React.createElement(RecekTextField, __assign({}, controllerField, { value: (_b = controllerField.value) !== null && _b !== void 0 ? _b : "", labelId: "ui-br-legaldeposits.publishers.field.contacts.info" })));
                                    } })),
                            React.createElement(Col, { xs: 12, sm: 6, md: 2 },
                                React.createElement(Controller, { control: control, name: "contacts.".concat(index, ".isPrimary"), render: function (_a) {
                                        var _b;
                                        var controllerField = _a.field;
                                        return (React.createElement(Checkbox, { checked: (_b = controllerField.value) !== null && _b !== void 0 ? _b : false, onChange: controllerField.onChange, label: formatMessage({
                                                id: "ui-br-legaldeposits.publishers.field.contacts.isPrimary",
                                            }) }));
                                    } })),
                            React.createElement(Col, { xs: 12 },
                                React.createElement(Button, { buttonStyle: "danger", onClick: function () { return removeContact(index); } },
                                    React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.button.remove" }))))); })),
                        React.createElement(Row, null,
                            React.createElement(Col, { xs: 12 },
                                React.createElement(Button, { onClick: handleAddContact },
                                    React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.publishers.edit.contacts.add" }))))))))));
};
export { PublisherContactsForm };
